var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-ricoma-gray-200",class:[_vm.classes.container]},[_c('VFormSelect',{attrs:{"initialSelectedOption":_vm.language.title,"options":_vm.langOptions,"resetStyles":true},on:{"onSelect":_vm.handleSetLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }